'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../index-448c776e.js');
require('tslib');
require('react');
require('../definitions-4ae1604d.js');
require('@prisjakt/design-tokens/light-theme-colors');
require('../lib-75591456.js');
require('../style-inject.es-71b52b81.js');



Object.defineProperty(exports, 'Alignment', {
	enumerable: true,
	get: function () { return index.Alignment; }
});
exports.Floater = index.Floater;
Object.defineProperty(exports, 'Positioning', {
	enumerable: true,
	get: function () { return index.Positioning; }
});
//# sourceMappingURL=index.js.map
